<template>
  <div class="center-cmp-wrapper">
    <div class="center-cmp" id="center-cmp"></div>
    <div class="equipment__count">
      <p>设备总数：{{ equipmentCount.sbamount }}</p>
      <!-- <p>正常运行：{{ equipmentCount.zcamount }}</p> -->
      <!-- <p>异常中：{{ equipmentCount.ycamount }}</p> -->
    </div>
  </div>
</template>

<script>
import { querysbfb, querysbfbtj } from '@/api/modules/dataView.js'
import '@/data/china'
export default {
  name: 'CenterCmp',
  components: {},
  props: {
    date: {
      type: Object,
      default: () => {
        return {
          startdate: '',
          enddate: '',
        }
      },
    },
  },
  data() {
    return {
      chart: null,
      equipmentCount: {
        sbamount: '3',
        ycamount: '2',
        zcamount: '1',
      },
    }
  },
  mounted() {
    this.$nextTick(() => {
      var chartDom = document.getElementById('center-cmp')
      this.chart = this.$echarts.init(chartDom)
      this.getData()
    })
  },
  methods: {
    async getData() {
      const mapData = await querysbfb(this.date)
      querysbfbtj(this.date).then(data => {
        if (data) {
          this.equipmentCount.sbamount = data[0].assets_code
        }
      })
      let ysdwamountData = []
      let sbamountData = []
      let maxNum = 0
      // let zcyxamountData = []
      for (const item of mapData) {
        ysdwamountData.push({
          name: item.province.replace('市', '').replace('省', ''),
          value: item.count_province || 0,
        })
        sbamountData.push({
          name: item.province.replace('市', '').replace('省', ''),
          value: item.assets_code || 0,
        })
        if (item.assets_code > maxNum) {
          maxNum = item.assets_code
        }
        // zcyxamountData.push({ name: item.addr, value: item.zcyxamount })
      }

      let option = {
        tooltip: {
          formatter: function(params) {
            const mySeries = option.series
            let resStr = params.name + '<br />'
            for (let i = 0; i < mySeries.length; i++) {
              for (let k = 0; k < mySeries[i].data.length; k++) {
                if (mySeries[i].data[k].name === params.name) {
                  resStr +=
                    mySeries[i].name +
                    ':' +
                    mySeries[i].data[k].value +
                    '<br />'
                }
              }
            }
            return resStr
          }, // 数据格式化
        },
        visualMap: {
          min: 0,
          max: maxNum,
          left: 'left',
          top: 'bottom',
          text: ['高', '低'], // 取值范围的文字
          inRange: {
            color: ['#e8ffc1', '#9ef5cf', '#65c6c4', '#0278ae', '#015668'], // 取值范围的颜色
            // color: ['lightskyblue','yellow', 'orangered']
          },
          show: false, //图注
        },
        geo: {
          map: 'china',
          roam: false, // 不开启缩放和平移
          zoom: 1.23, // 视角缩放比例
          label: {
            normal: {
              show: true,
              fontSize: '10',
              color: 'rgba(0,0,0,0.7)',
            },
          },
          itemStyle: {
            normal: {
              borderColor: 'rgba(0, 0, 0, 0.2)',
            },
            emphasis: {
              areaColor: '#F3B329', // 鼠标选择区域颜色
              shadowOffsetX: 0,
              shadowOffsetY: 0,
              shadowBlur: 20,
              borderWidth: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)',
            },
          },
        },
        series: [
          {
            name: '委预算单位个数',
            type: 'map',
            geoIndex: 0,
            data: ysdwamountData,
          },
          {
            name: '设备总数',
            type: 'map',
            geoIndex: 0,
            data: sbamountData,
          },
          // {
          //   name: '正常运行设备数',
          //   type: 'map',
          //   geoIndex: 0,
          //   data: zcyxamountData,
          // },
        ],
      }

      option && this.chart.setOption(option)
    },
  },
}
</script>

<style lang="scss" scoped>
.center-cmp-wrapper {
  position: relative;
  width: 100%;
  height: 60%;
  margin: 0px;
  padding: 0px;
}
.center-cmp {
  width: 100%;
  height: 100%;
  margin: 0px;
  padding: 0px;
  display: flex;
  flex-direction: column;
}
.equipment__count {
  position: absolute;
  left: 10px;
  bottom: 20px;
  font-weight: bold;
  p {
    margin-bottom: 10px;
  }
}
</style>
